import React, { useContext } from 'react';
import { ReactComponent as Expired } from '../../assets/subscription/Expired.svg';
import "../../components/subscription-component/style/ActivePlan.scss"
import { useTranslation } from 'react-i18next';
import CustomTypography from '../CustomTypography';
import AppContext from '../../config/AppContext';

const ExpiredPlan = ({ planName = "Premium Plan", renewalDate = "Plan ended on 01st February 2025" }) => {
    const { t } = useTranslation();
    const { mode } = useContext(AppContext);

    const typographyStyle = {
        fontFamily: "Gotham",
        textOverflow: "ellipsis", // Corrected typo
        whiteSpace: "nowrap",
        overflow: "hidden",
        width: "100%",
        color: mode == "dark" ? "#F8F8F8" : "#242424",
        opacity: "0.8",
        fontSize: "14px",
        lineHeight: "21px",
    }
    return (
        <div className='status-container'>
            <div className='status-code'
                style={{
                    color: mode == "dark" ? "#F8F8F8" : "#242424",
                }}
            >{t("RAL0829")}</div>
            <div className='details-box'
             style={{
                border:" 1px solid  #6C757D",
                backgroundColor:mode == "dark" ? "#333333" : "#FFFFFF"
             }}
            >
                <CustomTypography title={planName}
                    component={{
                        typography: {
                            sx: typographyStyle
                        }
                    }}
                >{planName}</CustomTypography>
                <CustomTypography title={renewalDate}
                    component={{
                        typography: {
                            sx: typographyStyle
                        }
                    }}
                >{renewalDate}</CustomTypography>
            </div>
            <Expired className='icon-box' />
        </div>
    )
}

export default ExpiredPlan
